import React from 'react'
import { Row, Col } from 'antd'
import PropTypes from 'prop-types'
import StockBrokerListing from './StockBrokerListing'

export default function CitiesContent({ allCities }) {
  return (
    <Row className="page-wrapper page">
      <Col xs={24} md={20}>
        <StockBrokerListing allCities={allCities} />
      </Col>
    </Row>
  )
}

CitiesContent.propTypes = {
  allCities: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
}
